export default __webpack_public_path__ + "static/media/pritam_image.c0a9b8d3.png";